import { fork } from 'redux-saga/effects';

import rootSagaCreator from '@/rootSaga';

type Saga = (...args: any[]) => Generator;

export default function* rootSaga(): Generator {
	const sagas = rootSagaCreator() as Saga[];

	for (const saga of sagas) {
		yield fork(saga);
	}
}
